import React from "react";
import { Result, Button } from "antd";
import { CloseCircleTwoTone } from "@ant-design/icons";
import { Link } from "react-router-dom";

const SubscriptionCancelled: React.FC = () => (
    <Result
        status="warning"
        icon={<CloseCircleTwoTone twoToneColor="#faad14" style={{ fontSize: 64 }} />}
        title="Subscription Cancelled"
        subTitle="You cancelled the subscription process. No changes have been made."
        extra={[
            <Link to="/subscriptions" key="plans">
                <Button type="primary">Return to Plans</Button>
            </Link>,
            <Link to="/dashboard" key="dashboard">
                <Button>Go to Dashboard</Button>
            </Link>,
        ]}
    >
        <p style={{ marginTop: 16, color: '#888' }}>
            If this was a mistake, you can try again from the subscriptions page.
        </p>
    </Result>
);

export default SubscriptionCancelled;
